/* Shared display helpers. Catalog names, media records and variant data remain unchanged. */
((root, factory) => {
  const presentation = factory();
  if (typeof module === 'object' && module.exports) module.exports = presentation;
  else root.EvolveProductPresentation = presentation;
})(typeof window === 'undefined' ? globalThis : window, () => {
  const key = source => {
    if (typeof source !== 'string' || !source) return '';
    try { return new URL(source, 'https://image.invalid').pathname.split('/').pop(); }
    catch { return ''; }
  };
  const isModel = text => /\bmodel\s+(shot|wearing)\b|\bon[- ]model\b|\bworn by\b/i.test(text || '');
  const hasNeutralOptions = options => Array.isArray(options) && options.every(option => /^(title|size|ringsize|length)$/i.test(String(typeof option === 'string' ? option : option?.name).replace(/[\s_-]/g, '')));
  const kind = photo => isModel(photo.alt) ? 'model'
    : /\blifestyle\s+view\b/i.test(photo.alt || '') ? 'lifestyle'
    : /\b(dimensions?|measurements?|size\s+(guide|chart|diagram)|scale\s+(guide|diagram))\b/i.test(photo.alt || '') ? 'scale'
    : 'detail';
  const cleanTitle = (text, multipleSizes = false) => {
    let title = String(text || '')
      .replace(/\bLeslie(?:'|’|&#39;|&apos;)s\s+|\bMadi K\s+/gi, '')
      .replace(/\b(10|14)K([YWR])\b/gi, (_, purity, color) => `${purity}K ${{Y:'Yellow',W:'White',R:'Rose'}[color.toUpperCase()]} Gold`)
      .replace(/\b((?:10|14)K (?:Yellow|White|Rose) Gold)\s+\1\b/gi, '$1')
      .replace(/\bGold Gold\b/gi, 'Gold')
      .replace(/\bLTW\b/gi, 'Lightweight')
      .replace(/\b(?:D\/C|Dia-cut)\b/gi, 'Diamond-cut')
      .replace(/\bPol\.(?=\s|$)/gi, 'Polished');
    if (multipleSizes) title = title.replace(/\s+Size\s*\d+(?:\.\d+)?\s*$/i, '');
    return title.replace(/(\d(?:\.\d+)?)\s*(mm|cm|in)\b/gi, '$1 $2').replace(/\s+/g, ' ').trim();
  };
  const cleanMediaAlt = (text, multipleSizes = false) => cleanTitle(multipleSizes
    ? String(text || '').replace(/\bSize\s*\d+(?:\.\d+)?(?=\s*(?:$|[-–—|,]))\s*/gi, '')
    : text, multipleSizes);
  const orderPhotos = (photos, featured = {}, optionNames = []) => {
    const seen = new Set();
    const unique = photos.filter(photo => {
      const identity = key(photo.src);
      if (!identity || seen.has(identity)) return false;
      seen.add(identity);
      return true;
    });
    if (!unique.length) return [];
    const allowProductPhoto = hasNeutralOptions(optionNames);
    const featuredKey = key(featured.src);
    const primary = unique.find(p => featured.id && String(p.id) === String(featured.id))
      || unique.find(p => featuredKey && key(p.src) === featuredKey)
      || (allowProductPhoto && unique.find(p => /\bproduct\s+photo\b/i.test(p.alt || '')))
      || (allowProductPhoto && unique.find(p => kind(p) === 'detail')) || unique[0];
    const rest = unique.filter(p => p !== primary);
    return [primary, ...rest.filter(p => kind(p) === 'model'), ...rest.filter(p => kind(p) === 'detail'), ...rest.filter(p => kind(p) === 'scale'), ...rest.filter(p => kind(p) === 'lifestyle')];
  };
  return {key, isModel, hasNeutralOptions, kind, cleanTitle, cleanMediaAlt, orderPhotos};
});
